import axios from 'axios';
import { createSignedPostRequest } from 'utils/createSignedRequestsHelpers';

export const createBusinessContact = async (
  businessId,
  contactData,
  activeEmployerInfo = {}
) => {
  const apiPath = `contacts/business/${businessId}`;

  const signedRequest = await createSignedPostRequest({
    apiPath,
    body: contactData,
    activeEmployerInfo,
  });

  const response = await axios(signedRequest);

  return response.data;
};
